var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8082 3.04848L11.4151 2.65267C11.2914 2.52906 11.1268 2.46096 10.9509 2.46096C10.7751 2.46096 10.6103 2.52906 10.4866 2.65267L6.00268 7.13681L1.51357 2.6477C1.39006 2.52409 1.22528 2.45609 1.04947 2.45609C0.873666 2.45609 0.708786 2.52409 0.585176 2.6477L0.192002 3.04107C-0.0640005 3.29687 -0.0640005 3.71356 0.192002 3.96937L5.53683 9.33341C5.66034 9.45692 5.82493 9.54395 6.00229 9.54395H6.00434C6.18025 9.54395 6.34483 9.45682 6.46835 9.33341L11.8082 3.9839C11.9319 3.86039 11.9998 3.69083 12 3.51502C12 3.33912 11.9319 3.1719 11.8082 3.04848Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_down.078a5b9b.svg";
export { ForwardRef as ReactComponent };